const translations = {
  fr: {
    nav: {
      dashboard: 'Dashboard', clients: 'Clients', profil: 'Mon Profil',
      invoices: 'Factures', quotes: 'Devis', proposals: 'Propositions',
      projects: 'Projets', agent: 'Agent IA', social: 'Réseaux Sociaux',
      abonnement: 'Abonnement', parametres: 'Paramètres',
      users: 'Utilisateurs', artisans: 'Artisans',
    },
    settings: {
      title: 'Paramètres', profil: 'Profil', password: 'Mot de passe',
      twofa: 'Authentification 2FA', apparence: 'Apparence',
      save: 'Enregistrer', saving: 'Enregistrement…', saved: 'Enregistré !',
      update: 'Mettre à jour', updating: 'Mise à jour…', updated: 'Mis à jour !',
      nom: 'Nom', email: 'E-mail', langue: "Langue de l'interface",
      genre: 'Genre', dob: 'Date de naissance', pays: 'Pays',
      langues_maitrisees: 'Langues maîtrisées',
      femme: 'Femme', homme: 'Homme', autre: 'Autre',
      delete_account: 'Supprimer le compte', delete_confirm: 'Cette action est irréversible.',
      current_password: 'Mot de passe actuel', new_password: 'Nouveau mot de passe', confirm_password: 'Confirmer le nouveau mot de passe',
      theme: 'Thème', density: "Densité d'affichage",
      dark: 'Sombre', light: 'Clair', auto: 'Auto',
      compact: 'Compact', normal: 'Normale', airy: 'Aérée',
    },
    common: { logout: 'Déconnexion', cancel: 'Annuler', loading: 'Chargement…' },
    login: { title: 'Connexion', email: 'Email', password: 'Mot de passe', submit: 'Se connecter', register: 'Créer un compte', twofa_title: 'Vérification 2FA', twofa_label: "Code d'authentification", twofa_placeholder: 'Code à 6 chiffres', twofa_submit: 'Vérifier' },
  },
  en: {
    nav: {
      dashboard: 'Dashboard', clients: 'Clients', profil: 'My Profile',
      invoices: 'Invoices', quotes: 'Quotes', proposals: 'Proposals',
      projects: 'Projects', agent: 'AI Agent', social: 'Social Media',
      abonnement: 'Subscription', parametres: 'Settings',
      users: 'Users', artisans: 'Artisans',
    },
    settings: {
      title: 'Settings', profil: 'Profile', password: 'Password',
      twofa: 'Two-Factor Auth', apparence: 'Appearance',
      save: 'Save', saving: 'Saving…', saved: 'Saved!',
      update: 'Update', updating: 'Updating…', updated: 'Updated!',
      nom: 'Name', email: 'Email', langue: 'Interface language',
      genre: 'Gender', dob: 'Date of birth', pays: 'Country',
      langues_maitrisees: 'Languages spoken',
      femme: 'Female', homme: 'Male', autre: 'Other',
      delete_account: 'Delete account', delete_confirm: 'This action is irreversible.',
      current_password: 'Current password', new_password: 'New password', confirm_password: 'Confirm new password',
      theme: 'Theme', density: 'Display density',
      dark: 'Dark', light: 'Light', auto: 'Auto',
      compact: 'Compact', normal: 'Normal', airy: 'Spacious',
    },
    common: { logout: 'Sign out', cancel: 'Cancel', loading: 'Loading…' },
    login: { title: 'Sign in', email: 'Email', password: 'Password', submit: 'Sign in', register: 'Create account', twofa_title: '2FA Verification', twofa_label: 'Authentication code', twofa_placeholder: '6-digit code', twofa_submit: 'Verify' },
  },
  es: {
    nav: {
      dashboard: 'Panel', clients: 'Clientes', profil: 'Mi Perfil',
      invoices: 'Facturas', quotes: 'Presupuestos', proposals: 'Propuestas',
      projects: 'Proyectos', agent: 'Agente IA', social: 'Redes Sociales',
      abonnement: 'Suscripción', parametres: 'Configuración',
      users: 'Usuarios', artisans: 'Artesanos',
    },
    settings: {
      title: 'Configuración', profil: 'Perfil', password: 'Contraseña',
      twofa: 'Autenticación 2FA', apparence: 'Apariencia',
      save: 'Guardar', saving: 'Guardando…', saved: '¡Guardado!',
      update: 'Actualizar', updating: 'Actualizando…', updated: '¡Actualizado!',
      nom: 'Nombre', email: 'Correo', langue: 'Idioma de interfaz',
      genre: 'Género', dob: 'Fecha de nacimiento', pays: 'País',
      langues_maitrisees: 'Idiomas hablados',
      femme: 'Mujer', homme: 'Hombre', autre: 'Otro',
      delete_account: 'Eliminar cuenta', delete_confirm: 'Esta acción es irreversible.',
      current_password: 'Contraseña actual', new_password: 'Nueva contraseña', confirm_password: 'Confirmar nueva contraseña',
      theme: 'Tema', density: 'Densidad de visualización',
      dark: 'Oscuro', light: 'Claro', auto: 'Auto',
      compact: 'Compacto', normal: 'Normal', airy: 'Espacioso',
    },
    common: { logout: 'Cerrar sesión', cancel: 'Cancelar', loading: 'Cargando…' },
    login: { title: 'Iniciar sesión', email: 'Correo', password: 'Contraseña', submit: 'Iniciar sesión', register: 'Crear cuenta', twofa_title: 'Verificación 2FA', twofa_label: 'Código de autenticación', twofa_placeholder: 'Código de 6 dígitos', twofa_submit: 'Verificar' },
  },
  de: {
    nav: {
      dashboard: 'Dashboard', clients: 'Kunden', profil: 'Mein Profil',
      invoices: 'Rechnungen', quotes: 'Angebote', proposals: 'Vorschläge',
      projects: 'Projekte', agent: 'KI-Agent', social: 'Soziale Medien',
      abonnement: 'Abonnement', parametres: 'Einstellungen',
      users: 'Benutzer', artisans: 'Handwerker',
    },
    settings: {
      title: 'Einstellungen', profil: 'Profil', password: 'Passwort',
      twofa: '2-Faktor-Auth', apparence: 'Erscheinungsbild',
      save: 'Speichern', saving: 'Speichert…', saved: 'Gespeichert!',
      update: 'Aktualisieren', updating: 'Aktualisiert…', updated: 'Aktualisiert!',
      nom: 'Name', email: 'E-Mail', langue: 'Oberflächensprache',
      genre: 'Geschlecht', dob: 'Geburtsdatum', pays: 'Land',
      langues_maitrisees: 'Gesprochene Sprachen',
      femme: 'Weiblich', homme: 'Männlich', autre: 'Andere',
      delete_account: 'Konto löschen', delete_confirm: 'Diese Aktion ist unwiderruflich.',
      current_password: 'Aktuelles Passwort', new_password: 'Neues Passwort', confirm_password: 'Neues Passwort bestätigen',
      theme: 'Thema', density: 'Anzeigedichte',
      dark: 'Dunkel', light: 'Hell', auto: 'Auto',
      compact: 'Kompakt', normal: 'Normal', airy: 'Luftig',
    },
    common: { logout: 'Abmelden', cancel: 'Abbrechen', loading: 'Laden…' },
    login: { title: 'Anmelden', email: 'E-Mail', password: 'Passwort', submit: 'Anmelden', register: 'Konto erstellen', twofa_title: '2FA-Verifizierung', twofa_label: 'Authentifizierungscode', twofa_placeholder: '6-stelliger Code', twofa_submit: 'Überprüfen' },
  },
  pt: {
    nav: {
      dashboard: 'Painel', clients: 'Clientes', profil: 'Meu Perfil',
      invoices: 'Faturas', quotes: 'Orçamentos', proposals: 'Propostas',
      projects: 'Projetos', agent: 'Agente IA', social: 'Redes Sociais',
      abonnement: 'Assinatura', parametres: 'Configurações',
      users: 'Usuários', artisans: 'Artesãos',
    },
    settings: {
      title: 'Configurações', profil: 'Perfil', password: 'Senha',
      twofa: 'Autenticação 2FA', apparence: 'Aparência',
      save: 'Salvar', saving: 'Salvando…', saved: 'Salvo!',
      update: 'Atualizar', updating: 'Atualizando…', updated: 'Atualizado!',
      nom: 'Nome', email: 'E-mail', langue: 'Idioma da interface',
      genre: 'Gênero', dob: 'Data de nascimento', pays: 'País',
      langues_maitrisees: 'Idiomas falados',
      femme: 'Feminino', homme: 'Masculino', autre: 'Outro',
      delete_account: 'Excluir conta', delete_confirm: 'Esta ação é irreversível.',
      current_password: 'Senha atual', new_password: 'Nova senha', confirm_password: 'Confirmar nova senha',
      theme: 'Tema', density: 'Densidade de exibição',
      dark: 'Escuro', light: 'Claro', auto: 'Auto',
      compact: 'Compacto', normal: 'Normal', airy: 'Espaçoso',
    },
    common: { logout: 'Sair', cancel: 'Cancelar', loading: 'Carregando…' },
    login: { title: 'Entrar', email: 'E-mail', password: 'Senha', submit: 'Entrar', register: 'Criar conta', twofa_title: 'Verificação 2FA', twofa_label: 'Código de autenticação', twofa_placeholder: 'Código de 6 dígitos', twofa_submit: 'Verificar' },
  },
};

export default translations;
